import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { PatientService } from 'src/services/patient.service'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useParams } from 'react-router-dom'

export default function ExternalPatientPage() {
  const { projectId: projectIdParam, remoteId } = useParams<{ projectId: string; remoteId: string }>()
  const projectId = Number(projectIdParam)
  const navigate = useLocalizedNavigate()

  const { error, data: patient } = useQuery({
    queryKey: ['external-patient', projectId],
    queryFn: () => PatientService.getExternalPatientByRemoteId(projectId, remoteId!),
  })

  useEffect(() => {
    if (patient?.id) {
      navigate(`/${projectId}/medical/patients/${patient.id}`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient?.id])

  if (error) return <ErrorQueryHandler error={error} />

  return <div className="loading" />
}
